import React from 'react';
import PublicLegalContentPage from '../../components/public/PublicLegalContentPage';

const CareersPage = () => (
  <PublicLegalContentPage
    slug="careers"
    seoTitle="Careers - Join Our Team | Pleerity Enterprise Ltd"
    seoDescription="Join Pleerity Enterprise as we develop secure automation, compliance, and documentation solutions for organisations across the UK."
    canonicalUrl="/careers"
  />
);

export default CareersPage;
